module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-39.e49598e3.jpg";